import { RowCrudStatus } from "../../common/types";
import {
  Currency,
  CurrencyCreateMutationVariables,
  CurrencyUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";

export type CurrencyValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  code: string;
  name: string;
};

export type CurrencyErrorsType = {
  code?: { message: string; fieldLabel: string };
  name?: { message: string; fieldLabel: string };
};

export function CurrencyValuesInit(): CurrencyValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    code: "",
    name: "",
  };
}

export type CurrencyType = Currency | CurrencyValuesType;

export function currencyDisplayId(
  source: Partial<Currency>,
  _langStore: LangStore
) {
  return (
    (source.code ?? _langStore.emptyStringSymbol) +
    " " +
    (source.name ?? _langStore.emptyStringSymbol)
  );
}

export function getCurrencyValues(
  source: CurrencyType,
  _langStore: LangStore,
  _duplicated: boolean = false
): CurrencyValuesType {
  const entityValues = CurrencyValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : currencyDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.code = source.code;
  entityValues.name = source.name;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getCurrencyUpdateVariables(
  values: CurrencyValuesType
): CurrencyUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    code: values.code,
    name: values.name,
  };
}

export function getCurrencyCreateVariables(
  values: CurrencyValuesType
): CurrencyCreateMutationVariables {
  return {
    code: values.code,
    name: values.name,
  };
}
